// src/features/filter/filterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { practiceDashboardDefaultTab } from '../config/practice';

const initialState = {
  currentDate: new Date().toLocaleDateString('en-CA', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }), // Apply client's system time zone
  // Default selected tab → "Active" (dashfilter 1). 7825 opens on tab 0 --
  // no status tab, the whole day -- as OSA's own build does.
  tab: practiceDashboardDefaultTab(),
};
console.log(new Date().toLocaleDateString('en-CA', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }),'dateee')
const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setCurrentDate: (state, action) => {
      state.currentDate = action.payload;  // Update current date
    },
    setTab: (state, action) => {
      state.tab = action.payload;  // Update selected tab index
    },
  },
});

// Export actions
export const { setCurrentDate, setTab } = filterSlice.actions;

// Export the reducer
export default filterSlice.reducer;
